import PublicAccountTransfer from './index';

export default {
  path: '/home/publicAccountTransfer',
  component: PublicAccountTransfer,
};
